export var SapDeltaCapability;
(function (SapDeltaCapability) {
    SapDeltaCapability["SAP_DELTA_CAPABILITY_ODP"] = "ODP";
    SapDeltaCapability["SAP_DELTA_CAPABILITY_SLT"] = "SLT";
    SapDeltaCapability["SAP_DELTA_CAPABILITY_NONE"] = "NONE";
})(SapDeltaCapability || (SapDeltaCapability = {}));
